// --- Basic Shopify Storefront API client setup ---

const SHOPIFY_DOMAIN = "toshi-straps.myshopify.com";
const STOREFRONT_TOKEN = "3187eb4485b4fc65e881681b80d45fef";

async function shopifyQuery(query) {
  const response = await fetch(`https://${SHOPIFY_DOMAIN}/api/2024-07/graphql.json`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-Shopify-Storefront-Access-Token": STOREFRONT_TOKEN
    },
    body: JSON.stringify({ query })
  });

  return response.json();
}


// --- Pagination + dataset setup ---

let currentPage = 1;
const PER_PAGE = 50;

let sortedMetaobjects = [];   // full dataset (all metaobjects)
let activeMetaobjects = [];   // current dataset (either full or search results)

function getSortOrder(obj) {
  return Number(obj.node.sort_order?.value || 0);
}

function getPageItems(page) {
  const start = (page - 1) * PER_PAGE;
  return activeMetaobjects.slice(start, start + PER_PAGE);
}


// --- Fetch Gallery Image metaobjects (with Tags field) ---

async function loadGalleryMetaobjects() {
  const query = `
  {
    metaobjects(type: "gallery_image", first: 250) {
      edges {
        node {
          id

          image: field(key: "image") {
            reference {
              ... on MediaImage {
                image {
                  url
                }
              }
            }
            value
          }

          alt_text: field(key: "alt_text") {
            value
          }

          credit: field(key: "credit") {
            value
          }

          Tags: field(key: "Tags") {
            value
          }

          sort_order: field(key: "sort_order") {
            value
          }
        }
      }
    }
  }
  `;

  const data = await shopifyQuery(query);
  const items = data.data.metaobjects.edges || [];

  // Sort by sort_order (highest first)
  sortedMetaobjects = items.slice().sort((a, b) => {
    return getSortOrder(b) - getSortOrder(a);
  });

  // Initially, active dataset is the full sorted list
  activeMetaobjects = sortedMetaobjects;

  renderGalleryPage(currentPage);
}


// --- Render one page of the gallery ---

function renderGalleryPage(page) {
  const pageItems = getPageItems(page);
  renderGallery(pageItems);
  renderPagination(activeMetaobjects.length);
}


// --- Render gallery into the page ---

function renderGallery(metaobjects) {
  const container = document.getElementById("gallery");
  if (!container) return;

  container.innerHTML = "";

  metaobjects.forEach((obj) => {
    const fields = {
      image: obj.node.image,
      alt_text: obj.node.alt_text,
      credit: obj.node.credit,
      tags: obj.node.Tags,
      sort_order: obj.node.sort_order
    };

    const imageUrl =
      fields.image?.reference?.image?.url ||
      fields.image?.value?.url ||
      fields.image?.value ||
      "";

    const caption = fields.alt_text?.value || "";
    const credit = fields.credit?.value || "";

    const item = document.createElement("div");
    item.className = "gallery-item";

    item.innerHTML = `
      <img src="${imageUrl}" alt="${caption}">
    `;

    // Click handler uses activeMetaobjects for correct indexing in current view
    item.addEventListener("click", () => {
      const globalIndex = activeMetaobjects.indexOf(obj);
      openLightbox(imageUrl, caption, credit, globalIndex);
    });

    container.appendChild(item);
  });
}


// --- Lightbox ---

function openLightbox(url, caption, credit, index) {
  const lightbox = document.querySelector(".lightbox");
  if (!lightbox) return;

  const lightboxImage = lightbox.querySelector(".lightbox-image");
  const lightboxCaption = lightbox.querySelector(".lightbox-caption");
  const lightboxCredit = lightbox.querySelector(".lightbox-credit");

  if (!lightboxImage || !lightboxCaption || !lightboxCredit) return;

  lightboxImage.src = url;
  lightboxCaption.textContent = caption;
  lightboxCredit.textContent = credit ? "© " + credit : "";

  lightbox.classList.add("active");

  // --- Lightbox navigation ---
  const prevBtn = document.querySelector(".lightbox-prev");
  const nextBtn = document.querySelector(".lightbox-next");

  if (prevBtn) {
    prevBtn.onclick = () => {
      if (index > 0) {
        const prevItem = activeMetaobjects[index - 1];

        const fields = {
          image: prevItem.node.image,
          alt_text: prevItem.node.alt_text,
          credit: prevItem.node.credit
        };

        const img =
          fields.image?.reference?.image?.url ||
          fields.image?.value?.url ||
          fields.image?.value ||
          "";

        const cap = fields.alt_text?.value || "";
        const cred = fields.credit?.value || "";

        openLightbox(img, cap, cred, index - 1);
      }
    };
  }

  if (nextBtn) {
    nextBtn.onclick = () => {
      if (index < activeMetaobjects.length - 1) {
        const nextItem = activeMetaobjects[index + 1];

        const fields = {
          image: nextItem.node.image,
          alt_text: nextItem.node.alt_text,
          credit: nextItem.node.credit
        };

        const img =
          fields.image?.reference?.image?.url ||
          fields.image?.value?.url ||
          fields.image?.value ||
          "";

        const cap = fields.alt_text?.value || "";
        const cred = fields.credit?.value || "";

        openLightbox(img, cap, cred, index + 1);
      }
    };
  }
}


// --- Close button ---

const lightboxClose = document.querySelector(".lightbox-close");
if (lightboxClose) {
  lightboxClose.addEventListener("click", () => {
    const lightbox = document.querySelector(".lightbox");
    if (lightbox) {
      lightbox.classList.remove("active");
    }
  });
}


// --- Render pagination controls ---

function renderPagination(totalItems) {
  const totalPages = Math.ceil(totalItems / PER_PAGE);
  const container = document.getElementById("gallery-pagination");
  if (!container) return;

  container.innerHTML = "";

  // --- Previous button ---
  const prev = document.createElement("a");
  prev.textContent = "Previous";
  prev.href = "#";
  prev.className = "gallery-page-link";
  prev.style.marginRight = "12px";

  if (currentPage > 1) {
    prev.addEventListener("click", (e) => {
      e.preventDefault();
      currentPage -= 1;
      renderGalleryPage(currentPage);
    });
  } else {
    prev.style.opacity = "0.4";
    prev.style.pointerEvents = "none";
  }

  container.appendChild(prev);

  // --- Page numbers ---
  for (let p = 1; p <= totalPages; p++) {
    const link = document.createElement("a");
    link.textContent = p;
    link.href = "#";
    link.className = p === currentPage ? "gallery-page-current" : "gallery-page-link";

    link.addEventListener("click", (e) => {
      e.preventDefault();
      currentPage = p;
      renderGalleryPage(currentPage);
    });

    container.appendChild(link);
  }

  // --- Next button ---
  const next = document.createElement("a");
  next.textContent = "Next";
  next.href = "#";
  next.className = "gallery-page-link";
  next.style.marginLeft = "12px";

  if (currentPage < totalPages) {
    next.addEventListener("click", (e) => {
      e.preventDefault();
      currentPage += 1;
      renderGalleryPage(currentPage);
    });
  } else {
    next.style.opacity = "0.4";
    next.style.pointerEvents = "none";
  }

  container.appendChild(next);
}

// --- Search logic (multi-tag AND matching, exact whole-tag matching) ---

function applyGallerySearch() {
  const input = document.getElementById("gallery-search");
  if (!input) return;

  const rawQuery = input.value.trim().toLowerCase();

  // Prevent accidental empty gallery on load or single-character searches
  if (rawQuery === "" || rawQuery.length < 2) {
    activeMetaobjects = sortedMetaobjects;
    currentPage = 1;
    renderGalleryPage(currentPage);
    return;
  }

  // Split user search by commas → multi-tag search
  const searchTags = rawQuery
    .split(",")
    .map((t) => t.trim().toLowerCase())
    .filter(Boolean);

  const results = sortedMetaobjects.filter((obj) => {
    const tagsField = obj.node.Tags;
    const tagsValue = tagsField?.value || "";

    // Split image tags by comma
    const tagList = tagsValue
      .split(",")
      .map((t) => t.trim().toLowerCase())
      .filter(Boolean);

    if (tagList.length === 0) return false;

    // AND logic: every search tag must match a whole tag
    return searchTags.every((tag) => tagList.includes(tag));
  });

  activeMetaobjects = results;
  currentPage = 1;
  renderGalleryPage(currentPage);
}


// --- Start the gallery + wire up search ---

loadGalleryMetaobjects();

// --- Debounce timer ---
let searchTimer = null;

// --- Wire up search with debounce ---
const searchInput = document.getElementById("gallery-search");
if (searchInput) {
  searchInput.addEventListener("input", () => {
    clearTimeout(searchTimer);
    searchTimer = setTimeout(() => {
      applyGallerySearch();
    }, 300);
  });
}

// --- Clear button resets search and gallery ---

const clearButton = document.getElementById("gallery-clear");
if (clearButton) {
  clearButton.addEventListener("click", () => {
    const input = document.getElementById("gallery-search");
    if (!input) return;

    input.value = "";
    activeMetaobjects = sortedMetaobjects;
    currentPage = 1;
    renderGalleryPage(currentPage);
  });
}
document.addEventListener("DOMContentLoaded", () => {

  let searchTimer = null;

  const searchInput = document.getElementById("gallery-search");
  const clearButton = document.getElementById("gallery-clear");

  if (searchInput && clearButton) {
    searchInput.addEventListener("input", () => {
      const value = searchInput.value.trim();

      if (value.length > 0) {
        clearButton.style.display = "inline-block";
      } else {
        clearButton.style.display = "none";
      }

      clearTimeout(searchTimer);
      searchTimer = setTimeout(() => {
        applyGallerySearch();
      }, 300);
    });
  }

  if (clearButton && searchInput) {
    clearButton.addEventListener("click", () => {
      searchInput.value = "";
      clearButton.style.display = "none";

      activeMetaobjects = sortedMetaobjects;
      currentPage = 1;
      renderGalleryPage(currentPage);
    });
  }

});
